// Switches for showing the site to the target audience before the product is linked up.
// Set them in landingpage/.env (see .env.example). CRA bakes REACT_APP_* values in at
// build time, so rebuild after changing any of them.

// Sign-in only works once the backend has its email + Firebase service-account keys.
// Keep it hidden while testers are on the site, so nobody lands on an error.
export const SHOW_SIGN_IN = process.env.REACT_APP_SHOW_SIGN_IN === 'true';

// Formspree form URL, e.g. https://formspree.io/f/abcdwxyz. Blank falls back to mailto.
export const FORMSPREE_ENDPOINT = process.env.REACT_APP_FORMSPREE_ENDPOINT || '';

// Microsoft Clarity project id (heatmaps, scroll depth, session recordings). Blank = off.
export const CLARITY_ID = process.env.REACT_APP_CLARITY_ID || '';
